import { render, staticRenderFns } from "./PortfolioBalancerReportPage.vue?vue&type=template&id=7b71058e&scoped=true"
import script from "./PortfolioBalancerReportPage.vue?vue&type=script&lang=ts"
export * from "./PortfolioBalancerReportPage.vue?vue&type=script&lang=ts"
import style0 from "./PortfolioBalancerReportPage.vue?vue&type=style&index=0&id=7b71058e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b71058e",
  null
  
)

export default component.exports